<template>
  <section
    class="tutorial"
    :class="isMobile() ? 'mobile-overlay' : ''"
  >
    <tutorial-tasks
      :tasks="tasks"
    />
    <tutorial-overlay
      v-if="
        tutorialState.anne.showAnne || tutorialState.tutorialMessage.showMessage
      "
      style="pointer-events: auto"
      @click.prevent=""
      @mousedown.prevent=""
      @mouseup.prevent=""
      @touchstart.prevent=""
      @touchend.prevent=""
    />
    <tutorial-anne
      v-if="tutorialState.anne.showAnne"
      :is-right="tutorialState.anne.isRight"
      instructor-name="benus2"
    />
    <tutorial-under-menu v-if="tutorialState.showUnderMenu" />
    <tutorial-message-box
      v-if="tutorialState.tutorialMessage.showMessage"
      :key="tutorialState.tutorialMessage.message"
      :type-write="tutorialCoreState.typeWriter"
      :class="{ offsetBot: tutorialState.tutorialMessage.offset }"
      :header-text="$t('utTutorialBenus')"
      :text="$t(tutorialState.tutorialMessage.message)"
      :color="tutorialState.tutorialMessage.color"
      :button-yellow-text="tutorialState.tutorialMessage.yellowText"
      :force-hide-white-text="tutorialState.tutorialMessage.yellowTextSpecial"
      @show-full-text="setTypewriteToInactive"
    />
    <tutorial-hand-settings
      v-if="tutorialState.mobile.show"
      style="pointer-events: auto"
      :img-url="`https://appspowerplaymanager.vshcdn.net/images/
        winter-sports/minigame/kayak/ui/tutorial/MOBIL_BM.png`"
      @mousedown.stop=""
      @mouseup.stop=""
      @touchstart.stop=""
      @touchend.stop=""
      @click-continue="continueTask"
    >
      <div class="mobiler">
        <div class="buttons">
          <div
            class="button-group"
            :class="{ reverse: !gameSettingsState.isLeft }"
          >
            <img
              width="150"
              height="200"
              :src="`${pathAssetsKayak}/ui/tutorial/button_biatlon_action.png`"
              alt="button1"
            >
            <img
              width="150"
              height="150"
              :src="`${pathAssetsKayak}/ui/tutorial/button_biatlon_movement.png`"
              alt="button2"
            >
          </div>
        </div>
      </div>
    </tutorial-hand-settings>
    <tutorial-buttons v-if="isMobile()" />
    <instruction-box
      v-if="tutorialState.showInstructionBox"
      :key="$t(tutorialState.instructionBoxText)"
      style="bottom: 12%; position: fixed"
      :text-for-parse="'[b]'+$t(tutorialState.instructionBoxText)+'[/b]'"
      :icon="tutorialState.instructionBoxIcon"
      only-left-text
    />
    <tutorial-info-keys v-if="!isMobile()" />
    <info-component
      v-if="tutorialState.showBarStart"
      glow
    />
  </section>
</template>

<script lang="ts">
import {
  WindowAspect,
  TutorialAnne,
  TutorialMessageBox,
  TutorialTasks,
  TutorialOverlay,
  TutorialHandSettings,
  InstructionBox,
  tutorialCoreState,
  gameSettingsState
} from '@powerplay/core-minigames-ui-ssm'
import {
  settings,
  tutorialManager
} from '@powerplay/core-minigames'
import type { TutorialObjective } from '@powerplay/core-minigames'
import TutorialUnderMenu from '@/components/Tutorial/TutorialUnderMenu.vue'
import { pathAssetsKayak } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import InfoComponent from '../InfoComponent.vue'
import { TutorialObjectiveIds } from '@/app/types/tutorialTasks'
import TutorialButtons from './TutorialButtons.vue'
import TutorialInfoKeys from './TutorialInfoKeys.vue'
import { tutorialState } from '@/stores'

export default defineComponent({
  name: 'TutorialLogicComponent',
  components: {
    TutorialAnne,
    TutorialMessageBox,
    TutorialTasks,
    TutorialOverlay,
    TutorialHandSettings,
    TutorialUnderMenu,
    InstructionBox,
    InfoComponent,
    TutorialButtons,
    TutorialInfoKeys
  },
  mixins: [WindowAspect],
  data() {

    return {
      tasks: [],
      pathAssetsKayak,
      tutorialState: tutorialState(),
      gameSettingsState: gameSettingsState(),
      tutorialCoreState: tutorialCoreState(),
    }

  },
  computed: {
    basicStyle() {

      return {
        'align-items': 'flex-end',
        width: '290px',
        height: '200px',
        padding: '20px'
      }

    }
  },

  watch: {
    tutorialState: {
      immediate: true,
      deep: true,
      handler() {

        this.updateTasks()

      }
    }
  },
  methods: {
    setTypewriteToInactive() {

      tutorialCoreState().typeWriter = false
      tutorialManager.setTypeWriting(false)

    },
    continueTask() {

      this.setThings()
      settings.saveValues()
      window.dispatchEvent(new Event('mousedown'))

    },
    setThings(): void {

      settings.update('quality', gameSettingsState().graphicsSettings)
      settings.update('sounds', gameSettingsState().volume ? 1 : 0)
      settings.update('qualityAuto', gameSettingsState().graphicsAuto ? 1 : 0)
      settings.update('isLeft', gameSettingsState().isLeft ? 1 : 0)

    },
    updateTasks() {

      this.tasks = tutorialState().objectives.map((objective: TutorialObjective) => {

        let name = this.$t(objective.name)
        if (objective.name === TutorialObjectiveIds.goodPaddles) {

          name = this.$t(objective.name).replace(
            '[number]',
            `${tutorialState().goodPaddles}/10`
          )

        }
        let color = 'blue'
        if (objective.passed) color = 'green'
        if (objective.failed) color = 'red'
        return {
          color,
          text: name
        }

      })

    }
  }
})
</script>

<style lang="less">
.tutorial {

  .offsetBot {
    top: 5%;
  }
    &.mobile-overlay {
      .tutorial-anne, .tutorial-mobil, .tutorial-hand-bottom {
          position: fixed;
      }
      .offsetBot {
        top: 10%;
      }
    }


  .tutorial-tasks {
    position: absolute;
    left: 1%;
    top: 17%;
  }
  .speed-bar {
    position: absolute;
    top: 60%;
    left: 55%;
    transform: translate(-50%, -50%);
  }
}
.mobiler {
    height: 100%;

    .buttons {
        position: relative;
        width: 100%;
        height: 100%;

        .button-group {
            position: absolute;
            bottom: 130px;
            left: 130px;
            right: 130px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &.reverse {
                flex-direction: row-reverse;
            }
        }
    }
}
</style>
